<template>
    <div class="animated fadeIn">

        <!-- Splash section -->
        <section class="hero is-medium has-border-bottom-gray">
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-vcentered">
                        <div class="column has-padding-top-2x-mobile">
                            <div class="columns is-centered is-vcentered contact-us-header-mailbox is-mobile">
                                <div class="column is-narrow padding-top-2x-mobile">
                                    <figure class="image healthcare-splash" v-if="!isMobile()">
                                        <img alt="Push to talk over cellular splash" src="./assets/healthcare-splash.svg">
                                    </figure>
                                    <figure class="image healthcare-splash mobile-screen" v-else>
                                        <img alt="Push to talk over cellular splash" src="./assets/healthcare-splash.svg">
                                    </figure>
                                </div>
                            </div>
                            <div class="columns is-centered padding-top-1x">
                                <h1 class="title is-size-2 has-text-centered-mobile padding-bottom-1x uptin-text-center">
                                    {{ $t('healthcare:healthcare.title') }}
                                </h1>
                            </div>
                            <div class="columns is-centered">
                                <h2 class="is-size-5 has-text-centered-mobile uptin-text-center small-container">
                                    {{ $t('healthcare:healthcare.subtitle') }}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- First section -->
        <section class="section is-background-dark1">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content is-mobile">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center text-yellow"
                            v-html="$t('healthcare:healthcare.first_title_up')">
                        </h3>
                    </div>
                </div>
                <div class="columns is-centered">
                     <div class="column content column-center">
                        <figure class="image img-400" v-if="!isMobile()">
                            <img alt="What is PTT?" src="./assets/healthcare-section1.svg">
                        </figure>
                        <figure class="image img-400 mobile-screen" v-else>
                            <img alt="What is PTT?" src="./assets/healthcare-section1.svg">
                        </figure>
                     </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-center uptin-text-7 text-white">
                            {{ $t('healthcare:healthcare.first_description1') }}
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <h4 class="is-size-4 small-container uptin-text-center uptin-text-center text-yellow">
                            {{ $t('healthcare:healthcare.first_middle') }}
                        </h4>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-center uptin-text-7 text-white">
                            {{ $t('healthcare:healthcare.first_description2') }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Second section -->
        <section class="section">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content is-mobile">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center text-dark"
                            v-html="$t('healthcare:healthcare.second_col1_title')">
                        </h3>
                    </div>
                </div>

                <div class="columns is-centered">
                    <div class="column content column-center">
                        <figure class="image img-500" v-if="!isMobile()">
                            <img alt="What is PTT?" src="./assets/healthcare-section2.svg">
                        </figure>
                        <figure class="image img-400 mobile-screen" v-else>
                            <img alt="What is PTT?" src="./assets/healthcare-section2.svg">
                        </figure>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-center uptin-text-7 text-dark">
                            {{ $t('healthcare:healthcare.second_col1_description') }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Third section -->
        <section class="section is-background-dark1">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center text-yellow"
                            v-html="$t('healthcare:healthcare.third_col1_title')">
                        </h3>
                    </div>
                </div>

                <div class="columns is-centered">
                    <div class="column content column-center">
                        <figure class="image img-600" v-if="!isMobile()">
                            <img alt="What is PTT?" src="./assets/healthcare-section3.svg">
                        </figure>
                        <figure class="image img-400 mobile-screen" v-else>
                            <img alt="What is PTT?" src="./assets/healthcare-section3.svg">
                        </figure>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container is-paddingless">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-center uptin-text-7 text-white">
                            {{ $t('healthcare:healthcare.third_col1_description') }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Forth section -->
        <section class="section">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content is-mobile">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center text-dark"
                            v-html="$t('healthcare:healthcare.forth_col1_title')">
                        </h3>
                    </div>
                </div>

                <div class="columns is-centered">
                    <div class="column content column-center">
                        <figure class="image img-500" v-if="!isMobile()">
                            <img alt="What is PTT?" src="./assets/healthcare-section4.svg">
                        </figure>
                        <figure class="image img-400 mobile-screen" v-else>
                            <img alt="What is PTT?" src="./assets/healthcare-section4.svg">
                        </figure>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <h4 class="is-size-4 small-container uptin-text-center text-dark">
                            {{ $t('healthcare:healthcare.forth_col1_description2') }}
                        </h4>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-center uptin-text-7 text-dark">
                            {{ $t('healthcare:healthcare.forth_col1_description1') }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Fifth section -->
        <section class="section is-background-dark1">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center text-yellow"
                            v-html="$t('healthcare:healthcare.fifth_col1_description')">
                        </h3>
                    </div>
                </div>

                <div class="columns has-padding-2x">
                    <div class="column intro-text content small-container">
                        <table class="table" style="background: transparent; direction: rtl; margin: 0;">
                            <thead>
                            <tr>
                                <th></th>
                                <th class="uptin-text-center uptin-text-center text-white">{{ $t('healthcare:healthcare.table_head1') }}</th>
                                <th class="uptin-text-center uptin-text-center text-white">{{ $t('healthcare:healthcare.table_head2') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="uptin-text-center text-white">{{ $t('healthcare:healthcare.feature1') }}</td>
                                <td class="uptin-text-center uptin-text-center text-green">{{ $t('healthcare:healthcare.doesnt') }}</td>
                                <td class="uptin-text-center uptin-text-center text-red">{{ $t('healthcare:healthcare.does') }}</td>
                            </tr>
                            <tr>
                                <td class=" uptin-text-center text-white">{{ $t('healthcare:healthcare.feature2') }}</td>
                                <td class="uptin-text-center uptin-text-center text-green">{{ $t('healthcare:healthcare.low') }}</td>
                                <td class="uptin-text-center uptin-text-center text-green">{{ $t('healthcare:healthcare.low') }}</td>
                            </tr>
                            <tr>
                                <td class=" uptin-text-center text-white">{{ $t('healthcare:healthcare.feature3') }}</td>
                                <td class="uptin-text-center uptin-text-center text-green">{{ $t('healthcare:healthcare.does') }}</td>
                                <td class="uptin-text-center uptin-text-center text-red">{{ $t('healthcare:healthcare.doesnt') }}</td>
                            </tr>
                            <tr>
                                <td class=" uptin-text-center text-white">{{ $t('healthcare:healthcare.feature4') }}</td>
                                <td class="uptin-text-center uptin-text-center text-green">{{ $t('healthcare:healthcare.does') }}</td>
                                <td class="uptin-text-center uptin-text-center text-red">{{ $t('healthcare:healthcare.doesnt') }}</td>
                            </tr>
                            <tr>
                                <td class=" uptin-text-center text-white">{{ $t('healthcare:healthcare.feature5') }}</td>
                                <td class="uptin-text-center uptin-text-center text-green">{{ $t('healthcare:healthcare.does') }}</td>
                                <td class="uptin-text-center uptin-text-center text-red">{{ $t('healthcare:healthcare.doesnt') }}</td>
                            </tr>
                            <tr>
                                <td class=" uptin-text-center text-white">{{ $t('healthcare:healthcare.feature6') }}</td>
                                <td class="uptin-text-center uptin-text-center text-green">{{ $t('healthcare:healthcare.does') }}</td>
                                <td class="uptin-text-center uptin-text-center text-red">{{ $t('healthcare:healthcare.doesnt') }}</td>
                            </tr>
                            <tr>
                                <td class=" uptin-text-center text-white">{{ $t('healthcare:healthcare.feature7') }}</td>
                                <td class="uptin-text-center uptin-text-center text-green">{{ $t('healthcare:healthcare.does') }}</td>
                                <td class="uptin-text-center uptin-text-center text-red">{{ $t('healthcare:healthcare.doesnt') }}</td>
                            </tr>
                            <tr>
                                <td class=" uptin-text-center text-white">{{ $t('healthcare:healthcare.feature8') }}</td>
                                <td class="uptin-text-center uptin-text-center text-green">{{ $t('healthcare:healthcare.does') }}</td>
                                <td class="uptin-text-center uptin-text-center text-red">{{ $t('healthcare:healthcare.doesnt') }}</td>
                            </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>

        <!-- Register section-->
        <section class="section is-background-yellow">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center"
                            v-html="$t('healthcare:healthcare.register_title')">
                        </h3>
                    </div>
                </div>

                <div class="columns is-centered">
                    <div class="column intro-text content small-container">
                        <p class="small-container uptin-text-center uptin-text-center">
                            {{ $t('healthcare:healthcare.register_description') }}
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container padding-top-1x uptin-text-center">
                        <a href="https://panel.uptin.app/signup" class="button uptin-splash-button is-background-dark1 text-white" active-class="is-active is-active--advertiser">
                            {{ $t('healthcare:healthcare.register_button') }}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style lang="scss">
    .healthcare-splash {
        max-width: 800px;
        min-width: 400px;
        margin: 2%;

        &.position-top {
            top: -1em;
        }

        &.mobile-screen {
            max-width: 400px;
            min-width: 200px;
        }
    }

</style>

<script>
    export default {
        components: {
        },
        name: 'healthcare',
        methods: {
            isMobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            }
        }
    }
</script>
